"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardHeader = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../../Text");
const View_1 = require("../../../View");
const WizardHeader_styles_1 = require("./WizardHeader.styles");
exports.WizardHeader = react_1.default.memo(function WizardHeader({ title, description }) {
    if (!title && !description) {
        return null;
    }
    return (react_1.default.createElement(WizardHeader_styles_1.StyledWizardHeader, null,
        title || '',
        description && (react_1.default.createElement(View_1.View, { indentTop: View_1.INDENT.s },
            react_1.default.createElement(Text_1.Text, { view: Text_1.TEXT_VIEW.secondary }, description)))));
});
//# sourceMappingURL=WizardHeader.js.map